import type { SXType } from "@dealer-center/core-components";
import { XMarkIcon, forceWrap } from "@dealer-center/core-components";
import styled from "styled-components";

export const StyledPagesClientSearchSearchPills = styled.span`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
`;

export const StyledCloseButton = styled(XMarkIcon)`
  height: 1em;
  width: 1em;
  margin-right: -3px;
  margin-left: 2px;
`;
export const BadgeSX: SXType = {
  ...forceWrap
};

export const StyledPagesClientSearchSearchPillsArea = styled.span`
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
`;
